import React from "react";
import { reduxForm, InjectedFormProps } from "redux-form";
import blue from "material-ui/colors/blue";
import { Button, CircularProgress } from "material-ui";

import ExtendedField from "../../../components/form/ExtendedField";
import renderTextfield from "../../../components/form/RenderTextField";
import validate from "./LoginPageFormValidator";
import CountDownTimer from "../../../components/Timer/CountDownTimer";

export interface LoginFormData {
    username: string;
    password: string;
}

const styles = {
    flex: {
        flex: 1,
    },
    menuButton: {
        marginLeft: 0,
        marginRight: -12,
    },
    inputWrapper: {
        marginBottom: 20,
    },
    loginForm: {
        color: "#646363",
    },
};

interface LoginFormProps {
    onSubmit: (data: LoginFormData) => void;
    attemptTimeout?: number;
    onAttemptTimeoutExpire: () => void;
}

interface LoginFormState {}

type LoginFormFormProps = LoginFormProps &
    InjectedFormProps<LoginFormData, LoginFormProps>;

const LoginForm: React.SFC<LoginFormFormProps> = (
    props: LoginFormFormProps
) => {
    return (
        <form
            style={styles.loginForm}
            onSubmit={props.handleSubmit(props.onSubmit)}
        >
            <div style={styles.inputWrapper} className="loginInput">
                <ExtendedField
                    component={renderTextfield}
                    name="username"
                    type="text"
                    placeholder=""
                    adornment=""
                    label={"Tunnus"}
                    required={true}
                />
            </div>
            <div className="loginInput">
                <ExtendedField
                    component={renderTextfield}
                    name="password"
                    type="password"
                    placeholder=""
                    adornment=""
                    label={"Salasana"}
                    required={true}
                />
            </div>
            <div className={"loginButton"}>
                <Button
                    variant="raised"
                    type="submit"
                    disabled={
                        props.submitting ||
                        props.invalid ||
                        props.attemptTimeout !== undefined
                    }
                >
                    {props.attemptTimeout !== undefined ? (
                        <CountDownTimer
                            attemptTimeout={props.attemptTimeout}
                            onAttemptTimeoutExpire={
                                props.onAttemptTimeoutExpire
                            }
                        />
                    ) : (
                        <>
                            Kirjaudu
                            {props.submitting && (
                                <CircularProgress
                                    size={24}
                                    style={{
                                        color: blue[500],
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        marginTop: -12,
                                        marginLeft: -12,
                                    }}
                                />
                            )}
                        </>
                    )}
                </Button>
            </div>
        </form>
    );
};

export default reduxForm<LoginFormData, LoginFormProps>({
    validate,
})(LoginForm);



// WEBPACK FOOTER //
// ./src/views/login/components/LoginPageForm.tsx